
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import PromptForm from "@/components/prompts/PromptForm";

const CreatePrompt = () => {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Navbar />
      
      <div className="flex-1 pt-24 pb-16 px-4 sm:px-6 lg:px-8">
        <div className="container mx-auto max-w-3xl">
          <header className="mb-10">
            <h1 className="text-3xl font-bold">Submit a New Prompt</h1>
            <p className="mt-2 text-muted-foreground">
              Share your expertise with the community
            </p>
          </header>
          
          <div className="bg-white dark:bg-gray-900 rounded-xl shadow-sm border border-border/40 p-6 animate-fade-in">
            <PromptForm />
          </div>
          
          <div className="mt-8 bg-secondary/30 rounded-xl p-6 border border-border/40">
            <h3 className="font-semibold mb-2">Tips for creating effective prompts:</h3>
            <ul className="space-y-2 text-sm">
              <li className="flex items-start gap-2">
                <span className="text-primary font-bold">•</span>
                <span>Be specific about the role you want the AI to assume</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary font-bold">•</span>
                <span>Include clear instructions about the desired format and content</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary font-bold">•</span>
                <span>Use placeholders like [PRODUCT NAME] for customizable elements</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary font-bold">•</span>
                <span>Consider edge cases and provide guidance for handling them</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary font-bold">•</span>
                <span>Test your prompt before submitting to ensure it produces the desired output</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default CreatePrompt;
